<template>
  <div class="w-screen min-h-screen overflow-y-auto overflow-x-hidden bg-white relative pb-20">
    <div class="w-full min-h-screen overflow-y-auto overflow-x-hidden bg-white relative">

      <!-- Header -->
      <div class="w-full bg-white px-4 py-3 border-b border-gray-200 flex justify-between items-center print:hidden">
        <div class="flex items-center gap-2">
          <button @click="$router.push({ name: 'JobSheet' })" class="text-blue-600 hover:text-blue-800">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </button>
          <div class="font-bold text-blue-600">KEMBALI</div>
        </div>
      </div>

      <!-- Content -->
      <div class="p-4">
        <!-- Title -->
        <div class="text-center mb-6">
          <h5 class="font-bold text-blue-600">EDIT JOB SHEET</h5>
          <h6 class="font-bold text-red-500">EF-PRINT</h6>
        </div>

        <div class="mb-8 p-4 border rounded-lg bg-gray-50 shadow-sm">
          <form @submit.prevent="submitForm">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <!-- Tanggal -->
              <div>
                <label class="block font-semibold mb-1 text-xs text-gray-700">Tanggal Pekerjaan :</label>
                <input v-model="form.tanggal" type="date" required class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500">
              </div>

              <!-- PIC Koordinator -->
              <div>
                <label class="block font-semibold mb-1 text-xs text-gray-700">PIC Koordinator :</label>
                <select v-model="form.pic_koordinator_id" class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500">
                  <option value="">-- Pilih PIC --</option>
                  <option v-for="u in users" :key="u.id_user" :value="u.id_user">{{ u.nama_lengkap }}</option>
                </select>
              </div>

              <!-- Pelanggan -->
              <div class="relative">
                <label class="block font-semibold mb-1 text-xs text-gray-700">Nama Pelanggan :</label>
                <input v-model="searchPelanggan" @focus="showPelangganDropdown = true" @blur="hidePelangganDropdown" type="text" placeholder="Cari Pelanggan..." class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500" />
                <ul v-show="showPelangganDropdown" class="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-40 overflow-y-auto shadow-lg">
                  <li v-if="filteredPelanggans.length === 0" class="px-3 py-2 text-sm text-gray-500">Tidak ditemukan</li>
                  <li v-for="p in filteredPelanggans" :key="p.id_pelanggan" @mousedown.prevent="selectPelanggan(p)" class="px-3 py-2 text-sm cursor-pointer hover:bg-blue-100">{{ p.nama }}</li>
                </ul>
              </div>

              <!-- Tempat -->
              <div class="md:col-span-2">
                <label class="block font-semibold mb-1 text-xs text-gray-700">Tempat / Lokasi :</label>
                <textarea v-model="form.tempat" rows="2" required class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500" placeholder="Masukkan lokasi pemasangan"></textarea>
              </div>

              <!-- Ukuran -->
              <div>
                <label class="block font-semibold mb-1 text-xs text-gray-700">Ukuran :</label>
                <input v-model="form.ukuran" type="text" required class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500" placeholder="Contoh: 2x3 m">
              </div>

              <!-- Jumlah Pasang -->
              <div>
                <label class="block font-semibold mb-1 text-xs text-gray-700">Jumlah Pasang :</label>
                <input v-model="form.jumlah_pasang" type="number" min="1" required class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500" placeholder="1">
              </div>

              <!-- Waktu Berangkat -->
              <div>
                <label class="block font-semibold mb-1 text-xs text-gray-700">Waktu Berangkat :</label>
                <select v-model="form.waktu_berangkat" required class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500">
                  <option value="" disabled>Pilih Waktu</option>
                  <option value="siang">Siang</option>
                  <option value="sore">Sore</option>
                  <option value="malam">Malam</option>
                </select>
              </div>

              <!-- Lama Pekerjaan -->
              <div>
                <label class="block font-semibold mb-1 text-xs text-gray-700">Estimasi Lama Pekerjaan (Jam) :</label>
                <input v-model="form.lama_pekerjaan" type="number" step="0.5" class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500" placeholder="Contoh: 2.5">
              </div>

              <!-- Laporan Checkboxes -->
              <div class="md:col-span-2 grid grid-cols-2 gap-4 my-2">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input type="checkbox" v-model="form.laporan_merangka" class="form-checkbox h-4 w-4 text-blue-600 rounded">
                  <span class="text-sm font-semibold text-gray-700">Laporan Merangka</span>
                </label>
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input type="checkbox" v-model="form.laporan_menempel" class="form-checkbox h-4 w-4 text-blue-600 rounded">
                  <span class="text-sm font-semibold text-gray-700">Laporan Menempel</span>
                </label>
              </div>

              <!-- Personil (Dynamic List) -->
              <div class="md:col-span-2 mt-2 p-3 border border-gray-200 rounded-md bg-white">
                <div class="flex justify-between items-center mb-2">
                  <label class="font-semibold text-xs text-gray-700">Anggota Personil :</label>
                  <button type="button" @click="addPersonil" class="bg-green-500 hover:bg-green-600 text-white py-1 px-3 rounded text-xs font-semibold">
                    + Tambah Personil
                  </button>
                </div>
                <div v-for="(p, index) in form.personils" :key="index" class="flex items-center gap-2 mb-2">
                  <select v-model="p.id_user" class="flex-1 border border-gray-300 py-1 px-2 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500">
                    <option value="">-- Pilih Karyawan --</option>
                    <option v-for="u in users" :key="u.id_user" :value="u.id_user">{{ u.nama_lengkap }}</option>
                  </select>

                  <button type="button" @click="removePersonil(index)" class="bg-red-500 hover:bg-red-600 text-white p-1.5 rounded" title="Hapus">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                <div v-if="form.personils.length === 0" class="text-xs text-gray-500 text-center py-2">
                  Belum ada personil yang ditambahkan
                </div>
              </div>

              <!-- Catatan -->
              <div class="md:col-span-2">
                <label class="block font-semibold mb-1 text-xs text-gray-700">Catatan Tambahan :</label>
                <textarea v-model="form.catatan" rows="3" class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500" placeholder="Masukkan catatan bila perlu"></textarea>
              </div>
            </div>

            <div class="flex justify-end gap-3 mt-6">
              <button type="button" @click="$router.push({ name: 'JobSheet' })" class="bg-gray-500 hover:bg-gray-600 text-white py-2 px-6 rounded-md font-semibold text-sm transition-colors">
                Batal
              </button>
              <button type="submit" :disabled="isLoading" class="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-md font-semibold text-sm transition-colors flex items-center justify-center min-w-[120px]">
                <span v-if="isLoading" class="mr-2">Menyimpan...</span>
                <span v-else>Simpan Data</span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <bottom-nav></bottom-nav>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import BottomNav from '../components/BottomNav.vue'

export default {
  name: 'EditJobSheet',
  components: { BottomNav },
  data () {
    return {
      id: this.$route.params.id,
      isLoading: false,
      users: [],
      pelanggans: [],
      searchPelanggan: '',
      showPelangganDropdown: false,
      form: {
        tanggal: new Date().toISOString().split('T')[0],
        tempat: '',
        ukuran: '',
        jumlah_pasang: 1,
        waktu_berangkat: '',
        lama_pekerjaan: '',
        laporan_merangka: false,
        laporan_menempel: false,
        catatan: '',
        pic_koordinator_id: '',
        pelanggan_id: '',
        personils: []
      }
    }
  },
  computed: {
    filteredPelanggans() {
      if (!this.searchPelanggan) return this.pelanggans
      const lower = this.searchPelanggan.toLowerCase()
      return this.pelanggans.filter(p => p.nama && p.nama.toLowerCase().includes(lower))
    }
  },
  mounted () {
    this.fetchUsers()
    this.fetchPelanggans()
    if (this.id) {
      this.fetchJobSheet()
    }
  },
  methods: {
    async fetchJobSheet () {
      try {
        this.isLoading = true
        const response = await axios.get(`/e_transaksi/job_sheet/get_detail/${this.id}`, {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          const data = response.data.data
          this.form.tanggal = data.tanggal
          this.form.tempat = data.tempat
          this.form.ukuran = data.ukuran
          this.form.jumlah_pasang = data.jumlah_pasang
          this.form.waktu_berangkat = data.waktu_berangkat
          this.form.lama_pekerjaan = data.lama_pekerjaan
          this.form.laporan_merangka = Number(data.laporan_merangka) === 1
          this.form.laporan_menempel = Number(data.laporan_menempel) === 1
          this.form.catatan = data.catatan
          this.form.pic_koordinator_id = data.pic_koordinator_id || ''
          this.form.pelanggan_id = data.pelanggan_id || ''
          this.searchPelanggan = data.pelanggan_nama || ''

          if (data.personils && data.personils.length > 0) {
            this.form.personils = data.personils
              .filter(p => p.id_user)
              .map(p => ({ id_user: p.id_user || '' }))
          } else {
            this.form.personils = []
          }
        } else {
          alert(response.data.message || 'Gagal memuat data')
        }
      } catch (error) {
        console.error('Failed to fetch job sheet:', error)
      } finally {
        this.isLoading = false
      }
    },
    async fetchUsers () {
      try {
        const response = await axios.get('/e_transaksi/job_sheet/get_users', {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          this.users = response.data.data
        }
      } catch (error) {
        console.error('Failed to fetch users:', error)
      }
    },
    async fetchPelanggans () {
      try {
        const response = await axios.get('/e_transaksi/job_sheet/get_pelanggans', {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          this.pelanggans = response.data.data
        }
      } catch (error) {
        console.error('Failed to fetch pelanggans:', error)
      }
    },
    selectPelanggan (p) {
      this.form.pelanggan_id = p.id_pelanggan
      this.searchPelanggan = p.nama
      this.showPelangganDropdown = false
    },
    hidePelangganDropdown () {
      setTimeout(() => {
        this.showPelangganDropdown = false
      }, 200)
    },
    addPersonil () {
      this.form.personils.push({ id_user: '' })
    },
    removePersonil (index) {
      this.form.personils.splice(index, 1)
    },
    async submitForm () {
      if (!this.form.tanggal || !this.form.tempat || !this.form.ukuran || !this.form.waktu_berangkat) {
        alert('Mohon lengkapi semua field yang wajib diisi!')
        return
      }

      this.isLoading = true

      try {
        const formData = new URLSearchParams()
        formData.append('token', this.$store.state.token)
        formData.append('id', this.id)
        Object.keys(this.form).forEach(key => {
          if (key === 'personils') {
            const validPersonils = this.form.personils
              .filter(p => p.id_user)
              .map(p => ({ id_user: p.id_user }))
            formData.append('personils', JSON.stringify(validPersonils))
          } else {
            formData.append(key, this.form[key])
          }
        })

        const response = await axios.post('/e_transaksi/job_sheet/update', formData)

        if (response.data.status) {
          alert(response.data.message || 'Job Sheet berhasil diupdate!')
          this.$router.push({ name: 'JobSheet' })
        } else {
          alert(response.data.message || 'Terjadi kesalahan saat menyimpan data.')
        }
      } catch (error) {
        console.error(error)
        alert('Terjadi kesalahan koneksi server.')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
